import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import swal from 'sweetalert2';
import { Select2OptionData } from 'ng2-select2/ng2-select2.interface';
import { RegisterUser } from '../../shared/models/register-user.model';
import { concat } from 'rxjs/observable/concat';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../shared/models/user.model';
import { DocumentTypeService } from '../../shared/services/documenttype.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  model: RegisterUser;

  recaptcha: string;

  showSpinner : boolean;

  showSpinnerTiposDocumento : boolean; 

  public tipoDocumentoSeleccionado: string;
  
  public tipoDocumentoSeleccionadoTexto: string;

  public informacionUsuario: Array<User>;

  public tiposdocumento: Select2OptionData[];

  public tipoUsuario: string;

  public tiposUsuario = [
    { value: 'C', display: 'Contratante' },
    { value: 'B', display: 'Beneficiario' }
  ];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _authService : AuthService,
    private _userService : UserService,
    private _documenttypeservice : DocumentTypeService
  ) {
    this.model = new RegisterUser("", "", "", "", "-1", "", "", false, false);
  }

  ngOnInit() {
    this.showSpinner = false;
    this.tipoUsuario = '';
    this.tipoDocumentoSeleccionado = '';
    this.showSpinnerTiposDocumento = true;
    this._documenttypeservice.getDocumentType("ti").subscribe(
      res => {

        let _optionDefault = this.getOptionDefault('Seleccione un tipo de documento...');
        let _optionCiudades = res;
        let _options = _optionDefault.concat(_optionCiudades);
        this.showSpinnerTiposDocumento = false;
        this.tiposdocumento = _options;
      },
      err => {
          this.showSpinnerTiposDocumento = false;
        console.log(err);
      }
    )

  }

  getOptionDefault(texto: string): any[] {
    return [{ id: '-1', text: texto }];
  }

  resolved(captchaResponse: string) {
    //console.log(`Resolved captcha with response ${captchaResponse}:`);
    this.recaptcha = captchaResponse;
  }

  public changedTipoDocumento(e: any): void {
    
    this.tipoDocumentoSeleccionado = e.value;
    this.tipoDocumentoSeleccionadoTexto = e.data[0].text;

  }

  infoContract() {

    swal({
      width: 600,
      showCloseButton: true,
      imageClass: 'imgLogo',
      imageUrl: './assets/images/carnet_mp.jpg',
      imageWidth: 600,
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-info btn-confirm-modal',
      confirmButtonText: 'Volver',
      buttonsStyling: false,
      focusConfirm: false,
    });

  }

  consultarUserInfo() {

    if (this.recaptcha === undefined || this.recaptcha === null) {
      
      swal({
        title: 'reCAPTCHA',
        html: '<p style="font-size:14px">No ha resuelto el captcha</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;

    }

    if (this.tipoUsuario === '') {
      swal({
        title: 'Tipo Usuario',
        html: '<p style="font-size:14px">Seleccione un tipo de usuario</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });

      return

    }

    if (this.tipoDocumentoSeleccionado === '' || this.tipoDocumentoSeleccionado === '-1'){
      swal({
        title: 'Tipo de Documento',
        html: '<p style="font-size:14px">Seleccione un tipo de documento</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });

      return
    }

    this.showSpinner = true;
    this._userService.getUserInfoNewPass(this.model.identificacion, this.tipoUsuario, this.tipoDocumentoSeleccionado).subscribe(
      res => {
        this.showSpinner = false;
        this.informacionUsuario = res;
        //console.log(res);
        /*swal({
          width: 400,
          showCloseButton: true,
          padding: 25,          
          html: '<div style="font-size:14px">' + res.message + '</div>',
          type: res.type,
          confirmButtonClass: 'btn btn-primary',
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false
        }).then((result) => {
          if (result.value) {            
            if(res.type === "success"){
              this._router.navigate(['/auth/sign_in']);
            }
          } 
        });*/

      },
      err => {
        this.showSpinner = false;
        console.log(err);
      }
    );   
  }

  RecuperarPassword(usuario: User) {
    
    if (this.recaptcha === undefined || this.recaptcha === null) {

      swal({
        title: 'reCAPTCHA',
        html: '<p style="font-size:14px">No ha resuelto el captcha</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;

    }

    if (this.tipoUsuario == '') {
      swal({
        title: 'Tipo Usuario',
        html: '<p style="font-size:14px">Seleccione una opción</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });

      return

    }

    this.showSpinner = true;
    this._authService.postNewPass(usuario.documentId, usuario.contractNumber).subscribe(
     // this._authService.postNewPass('email', '0',this.model.identificacion, this.tipoUsuario).subscribe(
      res => {
        this.showSpinner = false;
        swal({
          width: 400,
          showCloseButton: true,
          padding: 25,          
          html: '<div style="font-size:14px">' + res.message + '</div>',
          type: res.type,
          confirmButtonClass: 'btn btn-primary',
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false
        }).then((result) => {
          if (result.value) {            
            if(res.type === "success"){
              this._router.navigate(['/auth/sign_in']);
            }
          } 
        });

      },
      err => {
        this.showSpinner = false;
        console.log(err);
      }
    );   
  }

  onSubmit() {
    
    if (this.recaptcha === undefined || this.recaptcha === null) {

      swal({
        title: 'reCAPTCHA',
        html: '<p style="font-size:14px">No ha resuelto el captcha</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;

    }

    if (this.tipoUsuario == '') {
      swal({
        title: 'Tipo Usuario',
        html: '<p style="font-size:14px">Seleccione una opción</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });

      return

    }

    this.showSpinner = true;
    this._authService.postNewPass(this.model.email, this.model.numContrato).subscribe(
     // this._authService.postNewPass('email', '0',this.model.identificacion, this.tipoUsuario).subscribe(
      res => {
        this.showSpinner = false;
        swal({
          width: 400,
          showCloseButton: true,
          padding: 25,          
          html: '<div style="font-size:14px">' + res.message + '</div>',
          type: res.type,
          confirmButtonClass: 'btn btn-primary',
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false
        }).then((result) => {
          if (result.value) {            
            if(res.type === "success"){
              this._router.navigate(['/auth/sign_in']);
            }
          } 
        });

      },
      err => {
        this.showSpinner = false;
        console.log(err);
      }
    );   
  }

  back() {
    this._router.navigate(['/auth/sign_in']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/forgot-password/forgot-password.component.ts